import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserPages, UserPage } from './useUserPages';
import { findPageForPath } from '../utils/PageUtils';

/**
 * Resolves the current dashboard page from the route and user-accessible pages list.
 */
export function useCurrentPage(): UserPage | undefined {
  const location = useLocation();
  const { pages } = useUserPages();

  return useMemo(
    () => findPageForPath(location.pathname, pages),
    [location.pathname, pages],
  );
}
